import { render, staticRenderFns } from "./SemiologiasMain.vue?vue&type=template&id=56b0afc2"
import script from "./SemiologiasMain.vue?vue&type=script&lang=js"
export * from "./SemiologiasMain.vue?vue&type=script&lang=js"
import style0 from "./SemiologiasMain.vue?vue&type=style&index=0&id=56b0afc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports